/* kx-pdp-runtime.js — delad PDP-runtime
 *
 * Byggd 2026-08-29 ur den fungerande FixWax-sidan. Varje delsystem har redan
 * kostat tid en gang: kundvagns-skuffen, paketvaljaren, swipe-galleriet,
 * omtalekarusellen, platsen over samtyckesbanneret och videoautoplay.
 * Den skrivs INTE om per sida. Den inkluderas.
 *
 * Sidan levererar data via <script id="kx-product" type="application/json">,
 * som snippets/kx-pdp-runtime.liquid skriver.
 *
 * 2026-09-05 (Namu Care, Ludvigs punkt 6-8): la til fem opt-in TH.*-felt
 * (urgencyText/urgencyBg/freeshipBanner/checkoutLabel/payIcons) styrt av
 * kx-pdp-runtime.liquids nye valfria parametrar. Alle default til tomt/
 * false, sa Orthotal/Ultraflex x4/FixWax2 er BYTE-for-byte uendret —
 * verifiser det pa nytt neste gang noen rorer denne fila.
 *
 * Hookar sidan kan bara, i bada dialekterna:
 *   paketval        data-pick="0|1|2"      eller data-act="pickP0|pickP1|pickP2"
 *   kop             data-atc
 *   omtalepilar     data-rev="next|prev"   eller data-act="revNext|revPrev"
 *   policyrutor     data-policy="N"        eller data-act="openP0..openP5"
 *   stang policy    data-policy-close      eller data-act="closePolicy"
 *   villkorlig UI   data-cond="namn"
 *   textslots       data-v="namn"
 *
 * data-act-formen ar den som import_design_bundle.py skriver rakt ur en
 * Claude Design-export. Adaptern nedan oversatter den, sa en porterad sida
 * fungerar utan handarbete.
 */
(function(){
  var acts = document.querySelectorAll('[data-act]');
  for (var i=0; i<acts.length; i++) {
    var el = acts[i], a = el.getAttribute('data-act'), m;
    if ((m = /^pickP(\d+)$/.exec(a)))      el.setAttribute('data-pick', m[1]);
    else if (a === 'revNext')               el.setAttribute('data-rev', 'next');
    else if (a === 'revPrev')               el.setAttribute('data-rev', 'prev');
    else if ((m = /^openP(\d+)$/.exec(a)))  el.setAttribute('data-policy', m[1]);
    else if (a === 'closePolicy')           el.setAttribute('data-policy-close', '');
  }
})();


(function(){
  var el=document.getElementById('kx-product'); if(!el) return;
  var P; try{ P=JSON.parse(el.textContent); }catch(e){ return; }
  var vs=(P.variants||[]); if(!vs.length) return;

  /* Sprakslots. Runtimen DELAS mellan sidorna, sa strangarna far inte
     oversattas har — da foljer den norska sidan med. Sidan levererar sina
     egna i kx-product.t; utan den faller allt tillbaka pa norskan, som ar
     exakt det den norska sidan hade fore den har andringen. */
  function T(k, fallback){
    return (P.t && typeof P.t[k] === 'string' && P.t[k]) ? P.t[k] : fallback;
  }
  var UNIT=[1,2,3], sel=1;

  /* --- valgfri andre opsjon (storrelse) -------------------------------------
     En side som selger pakke X storrelse merker knappene med data-pack="2 stk"
     og data-size="L - XL". Finnes ingen [data-size] pa siden oppforer runtimen
     seg noyaktig som for: variant = vs[sel]. Ingen eksisterende side endres. */
  var sizeEls=[].slice.call(document.querySelectorAll('[data-size]'));
  var selSize=sizeEls.length ? sizeEls[0].getAttribute('data-size') : null;
  function packLabelFor(i){
    var el=document.querySelector('[data-pick="'+i+'"][data-pack]');
    return el ? el.getAttribute('data-pack') : null;
  }
  function norm(x){ return String(x||'').replace(/[\u2010-\u2015]/g,'-').replace(/\s+/g,' ').trim().toLowerCase(); }
  function current(){ return variantFor(sel); }
  function variantFor(sel){
    if(selSize){
      var pl=packLabelFor(sel);
      if(pl){
        var wantP=norm(pl), wantS=norm(selSize);
        for(var i=0;i<vs.length;i++){
          var t=norm(vs[i].title);
          if(t.indexOf(wantP)===0 && t.indexOf(wantS)>-1) return vs[i];
        }
      }
    }
    /* Uten storrelser: bind paa TITTEL naar kortet selv sier hvilken variant
       det er. Maalt 2026-09-06 paa Namu: siden har TO pakkekort mens produktet
       har TRE varianter, saa indeksmatchingen ga "3 barer"-kortet variant nr 2.
       Kunden klikket trepakke og fikk topakke, til feil pris. Et kort som
       navngir sin variant skal aldri bindes paa posisjon. */
    var pl2=packLabelFor(sel);
    if(pl2){
      var want=norm(pl2), j;
      for(j=0;j<vs.length;j++){ if(norm(vs[j].title)===want) return vs[j]; }
      for(j=0;j<vs.length;j++){ if(norm(vs[j].title).indexOf(want)>-1) return vs[j]; }
    }
    return vs[Math.min(sel,vs.length-1)];
  }
  /* Valutaen som males er den kurven FAKTISK har, ikke den siden ble bygget med.
     Maalt 2026-08-31: shopkorrex.com serverer sv/SEK paa /no-no/-adresser mot en
     svensk IP, mens /no-no/cart.js svarer NOK. Da skrev skuffen "SEK 679" over en
     kurv paa 679 NOK. Sidens verdi er fortsatt fallback naar kurven er tom. */
  var LIVECUR=null;
  /* Spraaket som formaterer belopet maa folge VALUTAEN, ikke butikken.
     Maalt 2026-09-06 paa Namu: butikkens primaerspraak er "en", saa
     Intl.NumberFormat('en', NOK) skrev "NOK 449" mens siden selv sa "449 kr".
     Samme belop, to skrivemaater, i samme kjoep. Vi velger derfor spraaket ut
     fra valutaen naar vi kjenner den, og faller tilbake paa sidens. */
  var CURLOC={NOK:'nb-NO',SEK:'sv-SE',DKK:'da-DK',EUR:'de-DE',GBP:'en-GB',USD:'en-US'};
  function fmt(c){
    var cur=LIVECUR||P.currency;
    var loc=CURLOC[cur]||P.locale||'nb-NO';
    try{ return new Intl.NumberFormat(loc,
      {style:'currency',currency:cur,maximumFractionDigits:0}).format(c/100); }
    catch(e){ return Math.round(c/100)+' '+cur; }
  }
  function set(n,v){ document.querySelectorAll('[data-v="'+n+'"]').forEach(function(x){x.textContent=v;}); }
  function cond(n,on){ document.querySelectorAll('[data-cond="'+n+'"]').forEach(function(x){
    on ? x.removeAttribute('hidden') : x.setAttribute('hidden',''); }); }
  function render(){
    var v=current(); if(!v) return;
    var n=UNIT[Math.min(sel,UNIT.length-1)];
    set('packLabel',v.title); set('packNote',(n*10)+' stifter');
    set('packPrice',fmt(v.price));
    set('packUnit', n>1 ? fmt(Math.round(v.price/n))+' per sett' : '');
    /* pris og besparelse rett i hvert kort */
    /* Prisene i kortene maa komme fra SAMME oppslag som kjopet gjor, ellers
       kan kortet vise en annen variant enn knappen legger i kurven. Maalt
       2026-09-07 paa Namu: trepakke-kortet viste 449, som er TOPAKKENS pris,
       mens knappen og kurven sa 499. Kortet leste paa indeks, kjopet paa navn. */
    var picks={};
    document.querySelectorAll('[data-pick]').forEach(function(el){
      picks[String(Number(el.getAttribute('data-pick'))||0)]=1; });
    Object.keys(picks).forEach(function(k){
      var kv=variantFor(Number(k)); if(!kv) return;
      set('p'+k+'price', fmt(kv.price));
      var sv=(kv.compare_at && kv.compare_at>kv.price) ? kv.compare_at-kv.price : 0;
      set('p'+k+'save', sv>0 ? '−'+fmt(sv) : '');
    });
    var save=(v.compare_at && v.compare_at>v.price) ? v.compare_at-v.price : 0;
    cond('hasSaving',save>0); set('savingLabel', save>0 ? 'Du sparer '+fmt(save) : '');
    [0,1,2].forEach(function(k){ cond('sel'+k, k===sel); });
    document.querySelectorAll('[data-pick]').forEach(function(x){
      x.setAttribute('aria-pressed', String(Number(x.getAttribute('data-pick'))===sel)); });
  }
  document.addEventListener('click',function(e){
    var open=e.target.closest && e.target.closest('[data-cartopen]');
    if(open){ e.preventDefault(); openDrawer(); return; }
    var sz=e.target.closest && e.target.closest('[data-size]');
    if(sz){ selSize=sz.getAttribute('data-size'); render(); return; }
    var pick=e.target.closest && e.target.closest('[data-pick]');
    if(pick){ sel=Number(pick.getAttribute('data-pick'))||0; render(); return; }
    var btn=e.target.closest && e.target.closest('[data-atc]');
    if(!btn || btn.disabled || btn.dataset.kxBusy==='1') return;
    e.preventDefault();
    /* En side kan levere egen linjevare via window.KX_ATC_ITEM() — brukes naar
       valget ikke er en enkel variant (f.eks. farge+storrelse PER PAR i en
       flerpakke, baaret som line item properties). Returnerer den {id,quantity,
       properties} som skal legges i kurven, eller null/undefined for aa avbryte
       (siden har allerede vist hvorfor). Definerer siden ingen slik funksjon
       oppfoerer runtimen seg noyaktig som foer — ingen eksisterende side endres. */
    var item;
    if (typeof window.KX_ATC_ITEM === 'function') {
      item = window.KX_ATC_ITEM();
      if (!item) return;
    } else {
      var v=current(); if(!v) return;
      item = {id:v.id, quantity:1};
    }
    /* Bugg funnet 2026-09-02 (Ultraflex, punkt 6+7): knappens opacity/
       pointer-events ble satt her men ALDRI nullstilt hvis fetch-kjeden
       feilet — knappen falt dod for godt, uten synlig feil, etter et
       enkelt nettverksglipp eller et gjenbesok fra bfcache. resetBtn()
       kjores na FoR fallback-posten, ikke bare i suksess-veien. */
    btn.dataset.kxBusy='1';
    function resetBtn(){ btn.style.opacity=''; btn.style.pointerEvents=''; btn.dataset.kxBusy=''; }
    btn.style.opacity='.6'; btn.style.pointerEvents='none';
    fetch(url('cart.js'),{credentials:'same-origin',headers:{Accept:'application/json'}})
    .then(asJson)
    .then(function(c){ return staleCart(c) ? freshCart() : c; })
    .then(function(){
      return fetch(url('cart/add.js'),{method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[item]})}).then(asJson);
    })
    .then(function(){
      resetBtn();
      openDrawer();
    }).catch(function(){
      resetBtn();
      /* Loven i denne fila (se build()-kommentaren under): ingen
         omdirigering til /cart. En rå <form>-post uten 'return_to'
         besvares av Shopify med redirect til standard-/cart/ — akkurat
         det Ludvig sa var borte 2026-09-02. return_to holder kunden pa
         siden ogsaa nar denne siste utveien ma brukes. */
      var f=document.createElement('form'); f.method='post';
      /* P.root ar '/sv-se' UTAN avslutande snedstreck pa en lokaliserad
         marknad, sa P.root+'cart/add' blev '/sv-secart/add' — HTTP 411.
         Bara primarmarknaden, dar root ar '/', rakade fungera. Samma
         normalisering som url() pa raden nedan gor for de andra anropen.
         MATT 2026-09-03: ett kundvagnsanrop UTAN marknadsprefix prissatter
         i butikens basvaluta EUR, som ingen marknad saljer i — en trasig
         eller oprefixad kundvagns-URL ar darfor inte bara ett 404. */
      f.action=(P.root||'/').replace(/\/+$/,'')+'/cart/add';
      var fields=[['id',item.id],['quantity',item.quantity||1],
        ['return_to', location.pathname+location.search]];
      if(item.properties){
        Object.keys(item.properties).forEach(function(k){
          fields.push(['properties['+k+']', item.properties[k]]);
        });
      }
      fields.forEach(function(kv){
        var i=document.createElement('input'); i.name=kv[0]; i.value=kv[1]; f.appendChild(i); });
      document.body.appendChild(f); f.submit();
    });
  });

  /* Bugg 2026-09-02: et besok via nettleserens tilbake-knapp kan gjenopplive
     siden fra bfcache med en ATC-knapp fanget midt i en tidligere klikk-
     handling (opacity/pointer-events fortsatt satt) eller skuffen staaende
     aapen med body.style.overflow='hidden' fra forrige visning. pageshow med
     event.persisted=true er signalet paa akkurat den gjenopplivingen — feier
     begge tilstandene rene saa knappen alltid virker etter et gjenbesok. */
  window.addEventListener('pageshow',function(e){
    if(!e.persisted) return;
    document.querySelectorAll('[data-atc]').forEach(function(b){
      b.style.opacity=''; b.style.pointerEvents=''; b.dataset.kxBusy='';
    });
    if(drawer){ drawer.style.display='none'; document.body.style.overflow=''; }
  });


  /* ---- Handlekorg: egen skuff, ingen omdirigering til /cart ---- */
  /* Skuffen er merkevaretilpasset. Sender siden ingen theme faller alt tilbake
     paa Hemmafix-verdiene, saa eksisterende sider ser noyaktig like ut. */
  var TH=(P.theme||{});
  var ORANGE=TH.accent||'#D9541F', INK=TH.ink||'#191A1D', MUTE='#6A6A66',
      /* CTA er den ENESTE fargen som far bryte merkets tone — kassaknappen.
         Sender siden ingen cta arver den accent, saa FixWax ser ut som for. */
      CTA=TH.cta||TH.accent||'#D9541F',
      LINE='rgba(25,26,29,.12)', TINT=TH.tint||'#FFF6F1', SOFT='#FAF9F7',
      HFONT=(TH.font||'Sora')+',system-ui,sans-serif',
      BFONT=(TH.font||'Figtree')+',system-ui,sans-serif',
      SELLER=TH.seller||'Korrex';
  var drawer, panel, listEl, sumEl, headCount, lastFocus=null;

  function elm(tag,css,text){
    var n=document.createElement(tag);
    if(css) n.style.cssText=css;
    if(text!=null) n.textContent=text;
    return n;
  }
  function url(x){ return (P.root||'/').replace(/\/+$/,'')+'/'+String(x).replace(/^\/+/,''); }
  function asJson(r){
    /* Shopify svarer HTML paa flere feil, ikke JSON */
    return r.text().then(function(s){
      try{ return JSON.parse(s); }
      catch(e){ throw new Error('Butikken svarte ikke som forventet. Prøv igjen om et øyeblikk.'); }
    });
  }
  function staleCart(c){ return !!(P.currency && c && c.currency && c.currency!==P.currency); }
  function freshCart(){
    return fetch(url('cart/clear.js'),{method:'POST',credentials:'same-origin',
      headers:{Accept:'application/json'}}).then(asJson);
  }

  function build(){
    drawer=elm('div','position:fixed;inset:0;z-index:2147483000;display:none;justify-content:flex-end;font-family:'+BFONT+'');
    drawer.setAttribute('role','dialog');
    drawer.setAttribute('aria-modal','true');
    drawer.setAttribute('aria-label',T('cart','Handlekorg'));
    var scrim=elm('div','position:absolute;inset:0;background:rgba(25,26,29,.38)');
    scrim.addEventListener('click',close);
    panel=elm('div','position:relative;width:min(430px,100%);height:100%;background:#fff;display:flex;flex-direction:column;box-shadow:-16px 0 48px -24px rgba(25,26,29,.5)');

    var head=elm('div','display:flex;align-items:center;gap:12px;padding:20px 22px;border-bottom:1px solid '+LINE);
    head.appendChild(elm('div','font-family:'+HFONT+';font-size:17px;font-weight:700;letter-spacing:-.02em;color:'+INK,T('cart','Handlekorg')));
    headCount=elm('span','display:inline-grid;place-items:center;min-width:23px;height:23px;padding:0 6px;border-radius:99px;background:'+ORANGE+';color:#fff;font-size:12px;font-weight:700','0');
    head.appendChild(headCount);
    var x=elm('button','margin-left:auto;background:none;border:0;font-size:24px;line-height:1;cursor:pointer;color:'+INK,'✕');
    x.setAttribute('aria-label','Lukk');
    x.addEventListener('click',close);
    head.appendChild(x);

    listEl=elm('div','flex:1;overflow:auto;padding:4px 22px');
    sumEl=elm('div','border-top:1px solid '+LINE+';padding:18px 22px 24px;background:'+SOFT);
    panel.appendChild(head);
    /* Urgency-rad + frakt-pill: opt-in via TH.urgencyText/TH.freeshipBanner
       (satt av kx-pdp-runtime.liquid). Tom streng pa alle sider som ikke
       sender parametrene -- ingen eksisterende skuff endres. */
    if (TH.urgencyText) {
      panel.appendChild(elm('div','background:'+(TH.urgencyBg||ORANGE)+';color:#fff;padding:9px 22px;font-family:'+BFONT+';font-size:12px;font-weight:800;text-align:center;line-height:1.35;letter-spacing:.01em', TH.urgencyText));
    }
    if (TH.freeshipBanner) {
      panel.appendChild(elm('div','display:flex;align-items:center;justify-content:center;gap:6px;background:'+TINT+';color:'+INK+';font-family:'+BFONT+';font-size:12.5px;font-weight:700;padding:9px 14px;margin:12px 22px 0;border-radius:8px','🚚 '+TH.freeshipBanner));
    }
    panel.appendChild(listEl); panel.appendChild(sumEl);
    drawer.appendChild(scrim); drawer.appendChild(panel);
    document.body.appendChild(drawer);
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape' && drawer && drawer.style.display!=='none') close();
    });
  }
  function close(){
    if(!drawer) return;
    drawer.style.display='none';
    document.body.style.overflow='';
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function openDrawer(){
    if(!drawer) build();
    lastFocus=document.activeElement;
    drawer.style.display='flex';
    document.body.style.overflow='hidden';
    giveConsentRoom();
    cartRender();
  }
  function line(it){
    var row=elm('div','display:flex;gap:13px;padding:16px 0;border-bottom:1px solid '+LINE);
    if(it.image){
      var im=elm('img','width:72px;height:72px;object-fit:cover;border-radius:8px;flex:none;background:'+TINT);
      im.src=it.image; im.alt=''; row.appendChild(im);
    }
    var mid=elm('div','flex:1;min-width:0');
    mid.appendChild(elm('div','font-size:10.5px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:'+ORANGE, P.brand || 'Hemmafix'));
    mid.appendChild(elm('div','font-family:'+HFONT+';font-size:15px;font-weight:600;letter-spacing:-.02em;margin-top:3px;color:'+INK,it.product_title));
    if(it.variant_title && it.variant_title!=='Default Title')
      mid.appendChild(elm('div','font-size:13px;color:'+MUTE+';margin-top:2px',it.variant_title));
    /* Egenskaper (line item properties) — f.eks. farge+storrelse valgt PER PAR i
       en flerpakke. Uten dette kan ikke kunden se hva de faktisk bestilte for
       et sammensatt kjop for de betaler. Noekler som starter med "_" er Shopifys
       egen konvensjon for skjulte/interne egenskaper og vises ikke. */
    if(it.properties){
      Object.keys(it.properties).forEach(function(k){
        if(k.charAt(0)==='_' || !it.properties[k]) return;
        mid.appendChild(elm('div','font-size:12.5px;color:'+MUTE+';margin-top:1px',k+': '+it.properties[k]));
      });
    }
    var qty=elm('div','display:flex;align-items:center;gap:0;margin-top:9px;border:1px solid '+LINE+';border-radius:999px;width:fit-content;overflow:hidden');
    function step(lbl,to){
      var b=elm('button','background:none;border:0;width:30px;height:28px;font-size:15px;line-height:1;cursor:pointer;color:'+INK,lbl);
      b.setAttribute('aria-label',lbl==='−'?'Færre':'Flere');
      b.addEventListener('click',function(){ change(it.key,to); });
      return b;
    }
    qty.appendChild(step('−',it.quantity-1));
    qty.appendChild(elm('span','min-width:24px;text-align:center;font-size:14px;font-weight:600;color:'+INK,String(it.quantity)));
    qty.appendChild(step('+',it.quantity+1));
    mid.appendChild(qty);
    var rm=elm('button','margin-top:8px;background:none;border:0;padding:0;font-size:13px;color:'+MUTE+';text-decoration:underline;cursor:pointer',T('remove','Fjern'));
    rm.addEventListener('click',function(){ change(it.key,0); });
    mid.appendChild(rm);

    var right=elm('div','text-align:right;flex:none');
    right.appendChild(elm('div','font-family:'+HFONT+';font-size:16px;font-weight:700;color:'+INK,fmt(it.final_line_price)));
    if(it.original_line_price>it.final_line_price){
      right.appendChild(elm('div','font-size:12.5px;color:#9A9A95;text-decoration:line-through;margin-top:2px',fmt(it.original_line_price)));
      right.appendChild(elm('div','font-size:12.5px;font-weight:700;color:'+ORANGE+';margin-top:3px','Du sparer '+fmt(it.original_line_price-it.final_line_price)));
    }
    row.appendChild(mid); row.appendChild(right);
    return row;
  }
  function change(key,qty){
    fetch(url('cart/change.js'),{method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({id:key,quantity:Math.max(0,qty)})})
    .then(asJson).then(function(){ cartRender(); })
    .catch(function(e){ alert(e.message); });
  }
  function badge(n){
    document.querySelectorAll('[data-cartcount]').forEach(function(el){
      /* En ikonknapp merker tallet sitt med data-cartnum. Da rores bare tallet,
         ikke ikonet. Uten et slikt barn beholdes den gamle tekstformen. */
      var num=el.querySelector('[data-cartnum]');
      if(num){ num.textContent=String(n); num.style.display = n>0 ? '' : 'none'; }
      else { el.textContent=T('cart','Handlekorg')+' ('+n+')'; }
    });
  }
  function cartRender(){
    fetch(url('cart.js'),{credentials:'same-origin',headers:{Accept:'application/json'}})
    .then(asJson).then(function(cart){
      LIVECUR=cart.currency||null;
      listEl.innerHTML=''; sumEl.innerHTML='';
      headCount.textContent=String(cart.item_count);
      badge(cart.item_count);
      if(!cart.items.length){
        listEl.appendChild(elm('div','padding:56px 0;text-align:center;color:'+MUTE+';font-size:14.5px',T('empty','Handlekorgen er tom.')));
        var c0=elm('button','display:block;margin:0 auto;background:none;border:0;font-size:13.5px;color:'+MUTE+';text-decoration:underline;cursor:pointer','Fortsett å handle');
        c0.addEventListener('click',close);
        listEl.appendChild(c0);
        return;
      }
      cart.items.forEach(function(it){ listEl.appendChild(line(it)); });

      var box=elm('div','background:#fff;border:1px solid '+LINE+';border-radius:10px;padding:15px 17px');
      function row(l,r,bold,colour){
        var d=elm('div','display:flex;justify-content:space-between;align-items:baseline;padding:5px 0');
        d.appendChild(elm('span','font-size:'+(bold?'16px':'14.5px')+';font-weight:'+(bold?'700':'400')+';color:'+INK,l));
        d.appendChild(elm('span','font-family:'+HFONT+';font-size:'+(bold?'17px':'14.5px')+';font-weight:700;color:'+(colour||INK),r));
        return d;
      }
      box.appendChild(row(T('subtotal','Delsum'),fmt(cart.items_subtotal_price)));
      /* Frakt-label, revidert 2026-09-02. Grensen for fri frakt var IKKE
         fastsatt for denne siden foer -- skuffen sa "Beregnes i kassen" som
         forr, den lovet ingenting den ikke kunne holde. Sider som na sender
         'freeship_min' (verifisert mot Shopify Admin API sine faktiske
         leveringssoner -- se kx-pdp-runtime.liquid) far et ekte svar,
         sjekket mot handlekurvens EGEN totalsum, ikke bare et statisk lofte.
         Sender siden ingen 'freeship_min' oppfoerer skuffen seg noyaktig
         som foer. */
      var shipLabel=T('shipCalc','Beregnes i kassen');
      if(P.freeShipMin!=null && P.freeShipMin>=0){
        shipLabel = cart.total_price>=P.freeShipMin ? T('free','Gratis') : T('shipCalc','Beregnes i kassen');
      }
      box.appendChild(row(T('shipping','Frakt'),shipLabel,false));
      box.appendChild(elm('div','height:1px;background:'+LINE+';margin:9px 0'));
      box.appendChild(row(T('total','Totalt'),fmt(cart.total_price),true));
      sumEl.appendChild(box);

      sumEl.appendChild(elm('div','text-align:center;font-size:13px;color:'+MUTE+';margin:13px 0 11px',
        T('soldBy','Selges av ')+SELLER+T('shipNote',' · Frakt og leveringstid vises i kassen')));

      var go=elm('button','width:100%;padding:17px;border:0;border-radius:10px;background:'+CTA+';color:#fff;font-family:'+HFONT+';font-size:15px;font-weight:700;letter-spacing:-.01em;cursor:pointer',TH.checkoutLabel||T('checkout','Gå til kassen'));
      go.addEventListener('click',function(){ location.href=url('checkout'); });
      sumEl.appendChild(go);

      /* Betalikoner: opt-in via TH.payIcons (kx-pdp-runtime.liquid bygger
         listan med asset_url server-side -- JS-filen kjenner ikke CDN-
         adressen selv). Tom liste pa alle sider som ikke sender
         cart_pay_icons -- ingen eksisterende skuff endres. */
      if (TH.payIcons && TH.payIcons.length) {
        var pay=elm('div','display:flex;align-items:center;justify-content:center;gap:8px;flex-wrap:wrap;margin-top:11px');
        TH.payIcons.forEach(function(src){
          var im=document.createElement('img'); im.src=src; im.alt='';
          im.style.cssText='height:20px;width:auto;display:block';
          pay.appendChild(im);
        });
        sumEl.appendChild(pay);
      }

      var cont=elm('button','display:block;margin:13px auto 0;background:none;border:0;font-size:13.5px;color:'+MUTE+';text-decoration:underline;cursor:pointer','Fortsett å handle');
      cont.addEventListener('click',close);
      sumEl.appendChild(cont);
      giveConsentRoom();
    }).catch(function(e){
      listEl.innerHTML='';
      listEl.appendChild(elm('div','padding:40px 0;text-align:center;color:#B03A28;font-size:14px',e.message));
    });
  }

  /* Samtykkebanneret ligger paa z-index 2147483647 -- maksverdien. Vi kan ikke
     legge oss over den, og vi skal ikke klikke bort noens samtykkevalg. Saa vi
     maaler hvor hoyt den dekker og gir skuffen og kjopsknappen plass over den. */
  function consentOverlap(){
    var c=document.querySelector('csm-cookie-consent');
    if(!c || !c.shadowRoot) return 0;
    var top=null;
    for(var y=window.innerHeight-2; y>window.innerHeight*0.30; y-=6){
      if(document.elementFromPoint(window.innerWidth/2,y)===c) top=y;
    }
    if(top==null) return 0;
    return Math.min(window.innerHeight-top+10, window.innerHeight*0.6);
  }
  function giveConsentRoom(){
    var h=consentOverlap();
    if(panel) panel.style.paddingBottom=h+'px';
    document.querySelectorAll('[data-m="stickywrap"]').forEach(function(el){
      el.style.marginBottom=h+'px';
    });
  }
  window.addEventListener('resize',giveConsentRoom);
  setInterval(giveConsentRoom,1200);   /* banneret forsvinner naar kunden svarer */

  /* korgen i toppen apner skuffen og viser riktig antall fra start */
  document.addEventListener('click',function(e){
    var h=e.target.closest && e.target.closest('[data-cartcount]');
    if(h){ e.preventDefault(); openDrawer(); }
  });
  fetch(url('cart.js'),{credentials:'same-origin',headers:{Accept:'application/json'}})
    .then(asJson).then(function(c){ badge(c.item_count); }).catch(function(){});


  /* ---- Omtaler: piler + native sveip ---- */
  (function(){
    var tr=document.querySelector('[data-m="revtrack"]');
    if(!tr) return;
    function stepBy(dir){
      var card=tr.children[0];
      if(!card) return;
      var w=card.getBoundingClientRect().width+16;   /* kort + gap */
      var maxL=tr.scrollWidth-tr.clientWidth;
      var from=tr.scrollLeft;
      var to=Math.max(0,Math.min(maxL,from+dir*w));
      if(Math.abs(to-from)<1) return;
      /* Myk scrolling -- baade scrollTo({behavior:'smooth'}) og CSS-ens
         scroll-behavior -- er drevet av requestAnimationFrame, som staar helt
         stille i en fane som ikke tegnes. Vi ber om den myke varianten, og
         setter posisjonen rett hvis ingenting flyttet seg. Da virker pilene
         uansett, og de er myke der nettleseren faktisk animerer. */
      try { tr.scrollTo({left:to, behavior:'smooth'}); }
      catch(e){ tr.scrollLeft=to; }
      setTimeout(function(){
        if(Math.abs(tr.scrollLeft-from)<2) tr.scrollLeft=to;
      },450);
    }

    document.addEventListener('click',function(e){
      var b=e.target.closest && e.target.closest('[data-rev]');
      if(!b) return;
      e.preventDefault();
      stepBy(b.getAttribute('data-rev')==='next'?1:-1);
    });
    /* pilene gaar matt naar det ikke er mer aa rulle til */
    function syncArrows(){
      var max=tr.scrollWidth-tr.clientWidth-2;
      document.querySelectorAll('[data-rev]').forEach(function(b){
        var slut=b.getAttribute('data-rev')==='next' ? tr.scrollLeft>=max : tr.scrollLeft<=2;
        b.style.opacity = slut ? '.35' : '';
      });
    }
    tr.addEventListener('scroll',syncArrows);
    window.addEventListener('resize',syncArrows);
    syncArrows();
  })();

  /* ---- Swipe-galleri: hero + miniatyrer blir en snap-strip ---- */
  (function(){
    var grid=document.querySelector('[data-m="herogrid"]');
    var thumbs=document.querySelector('[data-m="thumbs"]');
    if(!grid||!thumbs) return;
    var heroImg=grid.querySelector('img'); if(!heroImg) return;
    var box=heroImg.parentElement;
    var tImgs=[].slice.call(thumbs.querySelectorAll('img'));
    var items=[{s:heroImg.getAttribute('src'),a:heroImg.alt||''}].concat(
      tImgs.map(function(i){ return {s:i.getAttribute('src'),a:i.alt||''}; }));
    if(items.length<2) return;
    var strip=document.createElement('div'); strip.className='hmf-strip';
    items.forEach(function(it,i){
      var sl=document.createElement('div'); sl.className='hmf-slide';
      var im=document.createElement('img'); im.src=it.s; im.alt=it.a;
      im.loading = i? 'lazy':'eager';
      sl.appendChild(im); strip.appendChild(sl);
    });
    heroImg.remove(); box.appendChild(strip);
    var cells=[].slice.call(thumbs.children);
    function mark(i){ cells.forEach(function(c,k){ c.setAttribute('aria-current', String(k===i-1 || (i===0&&k===0))); }); }
    cells.forEach(function(c,k){
      c.addEventListener('click',function(){
        strip.scrollTo({left: strip.clientWidth*(k+1), behavior:'smooth'});
      });
    });
    var tick;
    strip.addEventListener('scroll',function(){
      clearTimeout(tick);
      tick=setTimeout(function(){
        mark(Math.round(strip.scrollLeft/Math.max(1,strip.clientWidth)));
      },60);
    },{passive:true});
    mark(0);
  })();

  set('guaranteeDays','90'); cond('showKlarna',true); cond('policyOpen',false);
  render();
  /* Autoplay blir blokkert ved sidelast, og observeren alene var ikke nok.
     Tre lag: spill naar videoen er i bildet, proev paa nytt ved forste
     brukerhandling, og vis controls hvis nettleseren fortsatt nekter. */
  (function(){
    var vids=[].slice.call(document.querySelectorAll('video'));
    if(!vids.length) return;
    vids.forEach(function(v){
      v.muted=true; v.setAttribute('muted',''); v.playsInline=true;
      v.setAttribute('playsinline',''); v.loop=true; v.preload='auto';
    });
    function tryPlay(v){
      if(!v.paused) return;
      var p=v.play();
      if(p&&p.catch) p.catch(function(){ v.setAttribute('controls',''); });
    }
    function visible(v){
      var r=v.getBoundingClientRect();
      return r.top < innerHeight*0.9 && r.bottom > innerHeight*0.1;
    }
    function sweep(){ vids.forEach(function(v){ if(visible(v)) tryPlay(v); }); }
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting) tryPlay(e.target); });
      },{threshold:0.15});
      vids.forEach(function(v){ io.observe(v); });
    }
    addEventListener('scroll',sweep,{passive:true});
    ['touchstart','pointerdown','keydown'].forEach(function(ev){
      addEventListener(ev,sweep,{passive:true,once:true});
    });
    vids.forEach(function(v){
      if(v.readyState>=2) tryPlay(v);
      else v.addEventListener('loadeddata',function(){ if(visible(v)) tryPlay(v); },{once:true});
    });
    setTimeout(sweep,400);
  })();
})();
